// extracted by mini-css-extract-plugin
export default {"createNewStudent":"ReferralMaterials_createNewStudent__Nk8l2","fontIcon":"ReferralMaterials_fontIcon__QpAC0"};